import * as amplitude from '@amplitude/analytics-browser';
import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import SocialMediaButtons from 'hb-react/frontoffice/components/SocialMediaButtons';
import { availableServices } from 'hb-react/frontoffice/components/SocialMediaButtons/helpers/socialMediaServices';
import useNavigatorShare from 'hb-react/shared/hooks/useNavigatorShare';
import IconShare from 'hb-react/shared/icons/Share';

const ShareButtons = ({
  title,
  text,
  url,
  selected,
  shareButtonLabel,
  shareAmplitudeEvent,
}) => {
  // Native share button must occur only if all available services are selected for current event.
  const isEveryAvailableSelected =
    Boolean(selected) &&
    availableServices.every((item) => selected.includes(item.name));

  const { handleShare, shareUrl } = useNavigatorShare({
    data: {
      title,
      text,
      url,
    },
    onShare: () => {
      amplitude.track(shareAmplitudeEvent);
    },
  });

  if (isEveryAvailableSelected && handleShare) {
    const shareButtonProps = shareUrl && {
      as: 'a',
      href: shareUrl,
      'data-bypass-router': true,
    };

    return (
      <Box>
        <Button icon={IconShare} onClick={handleShare} {...shareButtonProps}>
          {shareButtonLabel}
        </Button>
      </Box>
    );
  }

  return <SocialMediaButtons url={url} title={title} selected={selected} />;
};

ShareButtons.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  shareButtonLabel: PropTypes.string.isRequired,
  shareAmplitudeEvent: PropTypes.string.isRequired,
};

export default ShareButtons;
